import React from 'react';
import CustomSelect from 'components/CustomSelect';
import messages from './messages';
import FooterPagination from './FooterPagination';

const PostsFooter = ({count, pageFilter, setPageFilter, onChange}) => {
  const pages = Math.ceil(count / pageFilter.pageSize);

  const pageOptions = [
    {lable: 20, value: 20},
    {lable: 50, value: 50},
    {lable: 100, value: 100},
    {lable: 150, value: 150},
  ];

  const handleChange = (key, value) => {
    const filter = {...pageFilter};
    filter[key] = value;
    setPageFilter(filter);
    onChange(filter);
  };
  return (
    <>
      <div className="d-flex align-items-center filters-middle mt-4">
        <div className="page-select d-flex ml-auto mr-0  align-items-center">
          <span>{messages.postsPerPage}</span>
          <CustomSelect
            width={77}
            textColor="#373737"
            options={pageOptions}
            value={pageFilter.pageSize}
            getOptionLabel={(op) => op.lable}
            className="bg-gray4 mr-0 mb-0 radius"
            onChange={(e) => handleChange('pageSize', e)}
          />
        </div>
      </div>
      <div className="mt-4 post-list">
        <div className="paginations text-center">
          <FooterPagination
            size={pages || 1}
            page={pageFilter.pageNumber + 1}
            onChange={(e) => handleChange('pageNumber', e - 1)}
          />
        </div>
      </div>
    </>
  );
};

export default PostsFooter;
